module.exports = __webpack_public_path__ + "img/spjh.aae3a006.png";